import React from "react";
import { MaterialReactTable } from 'material-react-table'
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import TimelineIcon from "@mui/icons-material/Timeline";

function MaterialTable(props) {
  return (
    <>
      {props.role === "head" && (
        <Button
          onClick={() => props.setCreateModalOpen(true)}
          variant="contained"
        >
          New Task
        </Button>
      )}

      <MaterialReactTable
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              align: "center",
            },
            size: 120,
          },
        }}
        columns={props.columns}
        data={props.tableData}
        editingMode="modal" //default
        enableColumnOrdering
        enableEditing
        onEditingRowSave={props.handleSaveRowEdits}
        // onEditingRowCancel={props.handleCancelRowEdits}
        renderRowActions={({ row, table }) => (
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
            }}
          >
            <Tooltip arrow placement="left" title="Edit">
              <IconButton onClick={() => table.setEditingRow(row)}>
                <Edit />
              </IconButton>
            </Tooltip>
            {props.role === "head" && (
              <Tooltip arrow placement="right" title="Delete">
                <IconButton
                  color="error"
                  onClick={() => props.handleDeleteRow(row)}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip arrow placement="right" title="Delete">
              <IconButton
                color="error"
                onClick={() => props.handleOpenTimeline(row.original)}
              >
                <TimelineIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      />
    </>
  );
}

export default MaterialTable;
